import { render, staticRenderFns } from "./EditCommunityPayment.vue?vue&type=template&id=caf6eaca"
import script from "./EditCommunityPayment.vue?vue&type=script&lang=js"
export * from "./EditCommunityPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports